import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  ContainerP5,
  EstudioBox,
  EstudiosContainer,
  IconsBox,
} from "./localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import CirculoError from "_+_Portal/assets/images/generico/CirculoError";
import CirculoTildeOk from "_+_Portal/assets/images/generico/CirculoTildeOk";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import puntoControlImage from "_+_Portal/assets/images/generico/puntoControl.png";

const EstudiosLabo = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { ordenDigitalDispatch } = useContext(PortalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  // const [estudiosList, setEstudiosList] = useState([
  //   {
  //     id: 0,
  //     descripcion: "GLUCEMIA",
  //     aprobado: true,
  //   },
  //   {
  //     id: 1,
  //     descripcion: "HEMOGRAMA",
  //     aprobado: false,
  //   },
  //   {
  //     id: 2,
  //     descripcion: "HEPATOGRAMA",
  //     aprobado: true,
  //   },
  //   {
  //     id: 3,
  //     descripcion: "FSH - HORMONA FOLICULO ESTIMULANTE",
  //     aprobado: true,
  //   },
  // ]);
  const [loading, setLoading] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"Protocolo"}
        subtitle={"Turno de laboratorio"}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              <p className="rb24b">ATENCIÓN</p>
              <img
                src={puntoControlImage}
                style={{ width: "150px" }}
                alt="Icono ilustrativo"
              />
              {/* <TurnoNoEncontrado
                state={[]}
                loadingState={loading}
                texto={"ATENCIÓN"}
                recomendacion={
                  "El turno fue tomado correctamente por favor dirigite al punto de control para continuar con la recepcion del turno."
                }
              /> */}
              <p className="txtTurno rb16l">
                El turno fue tomado correctamente por favor dirigite al punto de
                control para continuar con la recepcion del turno.
              </p>
              <ButtonP5 onClick={() => volver()}>Volver al inicio</ButtonP5>
              {/* <IconsBox>
                <div className="rb14m icons-box-title">
                  <CirculoTildeOk />
                  Confirmado
                </div>
                <div className="rb14m icons-box-title">
                  <CirculoError />
                  Pendiente
                </div>
              </IconsBox>
              <EstudiosContainer>
                {estudiosList?.length > 0 ? (
                  estudiosList.map((element, index) => {
                    return (
                      <EstudioBox key={index}>
                        <p>
                          {element.aprobado ? (
                            <CirculoTildeOk width={30} />
                          ) : (
                            <CirculoError size={30} />
                          )}
                        </p>
                        <p className="rb16m">{element.descripcion}</p>
                      </EstudioBox>
                    );
                  })
                ) : (
                  <></>
                )}
              </EstudiosContainer> */}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default EstudiosLabo;
